
<template>

<div >
  <div class="back" @click="GoBack" ><i class="fas fa-chevron-left"></i>
  戻る
  </div>
  <div class="profile-container" >


    <div class="profile-main-content">
      <h1>きみの <ruby>
          <rb>情報</rb>
          <rt>じょうほう</rt>
        </ruby> <span>Your Information</span></h1>

        <!-- {{providerId}} -->
    <!-- <div style="width:600px;">{{rawUser.isAnonymous}}</div>     -->
<!-- <div style="width:600px;">{{rawUser.providerData[0].providerId}}</div> -->
<!-- <div style="width:600px;">{{rawUser}}</div> -->

<div class="row"
v-if="providerId==='google.com'"
v-bind:class="{disable:CurrentEditContet!=='name' && CurrentEditContet!==''}" 
style="margin-top:0px">
あなたは「グーグルアカウント」でログインしています。
*以下の情報を編集しても「グーグルアカウント」には影響しませんので、自由に編集ください。
</div>

<div class="row"
v-if="providerId==='facebook.com'"
v-bind:class="{disable:CurrentEditContet!=='name' && CurrentEditContet!==''}" 
style="margin-top:0px">
あなたは「Facebookアカウント」でログインしています。
*以下の情報を編集しても「Facebookアカウント」には影響しませんので、自由に編集ください。
</div>

<div class="row"
v-if="providerId==='phone'"
v-bind:class="{disable:CurrentEditContet!=='name' && CurrentEditContet!==''}" 
style="margin-top:0px">
あなたは「電話番号」でログインしています。

</div>


<div class="row"
v-if="rawUser.isAnonymous==true"
v-bind:class="{disable:CurrentEditContet!=='name' && CurrentEditContet!==''}" 
style="margin-top:0px">
アカウントをぜひご登録ください！（無料）
<br />
データも引き継がれます！
</div>
<!-- =======================
名前:
=======================-->
<div class="row"
v-bind:class="{disable:CurrentEditContet!=='name' && CurrentEditContet!==''}" 
style="margin-top:0px">

               <!-- 名前の編集：表示版 -->
               <div v-if="CurrentEditContet!=='name'" class="row-flex">
                <t-input v-model="loginUser.displayName"
                :readonly=true
                :enterToEditEnd =false
                placeholder="名前"
                label="・なまえ"
                iconClassName="far fa-user"
                radius="20px"
                ></t-input> 
                <div @click="EditName" class="button-edit">
                    <i class="far fa-edit"></i>
                    かえる
                </div>
                </div>


              <!-- 名前の編集：入力版 -->
               <div v-if="CurrentEditContet==='name'" class="row-input">
                <t-input v-model="ruleForm.name"
                name="userName"
                ref="userNameInput"
                v-validate="'required|max:20'"
                data-vv-as="「名前」"
                :maxlength=25
                v-bind:class="{disable:IsLoadingName}"
                :enterToEditEnd =false
                placeholder="名前"
                label="・なまえ"
                iconClassName="far fa-user"
                radius="20px"
                :isShowErrorMessage="errors.has('userName')"
                :errorMessage="errors.first('userName')"
                ></t-input> 

                <!-- ボタン：保存 -->
                <!-- ボタン類 -->
　　            <div class="row-buttons">
                  <div 
                v-bind:class="{disable:IsLoadingName || errors.has('userName')}"
                @click="SaveName" class="button-edit">
                    <i class="far fa-check-circle"></i>
                    ほぞん
                </div>

                <div 
                v-bind:class="{disable:IsLoadingName}"
                @click="SaveName('cancel')" class="button-edit cancel">
                  <i class="far fa-times-circle"></i>
                  キャンセル
                </div>
               </div>
                

                <!-- ローディング -->
                <t-loading class="loading-item" :isLoading="IsLoadingName"></t-loading>

                </div>

                
</div>
<div>
<!-- <input v-validate="'required|email'" name="email" type="text">
<span>{{ errors.first('email') }}</span> -->
</div>
<!-- =======================
メール:
=======================-->
<div  class="row"
v-if="providerId=='password' && rawUser.isAnonymous==false"
v-bind:class="{disable:CurrentEditContet!=='email' && CurrentEditContet!==''}" 
 style="margin-top:10px">
<div >
      <!-- メール：表示のみ -->
      <div v-if="CurrentEditContet!=='email'" class="row-flex">
        <t-input v-model="loginUser.email"
        :readonly=true
        :enterToEditEnd =false
        placeholder="メールアドレス"
        label="・メールアドレス"
        iconClassName="far fa-envelope"
        radius="20px"
        ></t-input> 
       

        <div @click="EditMailAddress" class="button-edit">
            <i class="far fa-edit"></i>
            かえる
        </div>
      </div>        
</div>

<!-- メールの編集 -->
<div class="row-input loading-container" v-if="CurrentEditContet==='email'">
  <!-- ローディング -->
  <t-loading class="loading-item" :isLoading="IsLoadingEmail"></t-loading>
  <t-input v-model="ruleForm.email"
                v-validate="'required|email|max:254'" 
                name="email"
                ref="emailInput"
                :enterToEditEnd =false
                v-bind:class="{disable:IsLoadingEmail}"
                :maxlength=254
                placeholder="メールアドレス"
                inputType="text"
                label="・メールアドレス"
                iconClassName="fas fa-envelope"
                :isShowErrorMessage="errors.has('email')"
                :errorMessage="errors.first('email')"
                radius="20px"
                ></t-input> 
               

                <!-- 確認用パスワード -->
                <t-input v-model="ruleForm.PasswordForUpdateEmail"
                 v-validate="'required|min:6|max:20'" 
                name="passwordForUpdateEmail"
                :enterToEditEnd =false
                v-bind:class="{disable:IsLoadingEmail}"
                inputType="password"
                :maxlength=20
                placeholder="パスワード"
                style="margin-top:10px;"
                label="・メールアドレスをかえるには、パスワードをいれてね！"
                iconClassName="fas fa-key"
                :isShowErrorMessage="errors.has('passwordForUpdateEmail')"
                :errorMessage="errors.first('passwordForUpdateEmail')"
                radius="20px"
                ></t-input> 
                
                
                <!-- ボタン類 -->
　　            <div class="row-buttons">
                  <div @click="SaveEmail" 
                  v-bind:class="{disable:IsLoadingEmail　|| errors.has('email') || errors.has('passwordForUpdateEmail') }" 
                  class="button-edit">
                    <i class="far fa-check-circle"></i>
                    保存
                  </div>
                  <div @click="SaveEmail('cancel')" v-bind:class="{disable:IsLoadingEmail}" class="button-edit cancel">
                    <i class="far fa-times-circle"></i>
                    キャンセル
                  </div>
                </div>
    
</div>
</div>


<!-- =======================
パスワード:
=======================-->
<div  class="row"
v-if="providerId=='password' && rawUser.isAnonymous==false"
v-bind:class="{disable:CurrentEditContet!=='password' && CurrentEditContet!==''}" 
 style="margin-top:10px">

<!-- パスワードの編集：表示版 -->
<div v-if="CurrentEditContet!=='password'" class="row-flex">
  <t-input v-model="ruleForm.DammyPassword"
  :readonly=true
  :enterToEditEnd =false
  placeholder=""
  label="・パスワード"
  iconClassName="fas fa-key"
  radius="20px"
  ></t-input> 

  <div @click="EditPassword" class="button-edit">
      <i class="far fa-edit"></i>
      かえる
  </div>
</div>       

<!-- 編集：パスワード -->
<div class="row-input loading-container" v-if="CurrentEditContet==='password'">
  <!-- ローディング -->
  <t-loading class="loading-item" :isLoading="IsLoadingPassword"></t-loading>
  <t-input v-model="ruleForm.Password"
                v-validate="'required|min:6|max:20'" 
                name="nowPassword"
                ref="nowPasswordInput"
                v-bind:class="{disable:IsLoadingPassword}"
                :enterToEditEnd =false
                :maxlength=20
                placeholder="いまのパスワード"
                inputType="password"
                label="・いまのパスワード"
                iconClassName="fas fa-key"
                :isShowErrorMessage="errors.has('nowPassword')"
                :errorMessage="errors.first('nowPassword')"
                radius="20px"
                ></t-input> 
               
                <t-input v-model="ruleForm.NewPassword"
                v-validate="'required|min:6|max:20'" 
                
                name="newPassword"
                v-bind:class="{disable:IsLoadingPassword}"
                :enterToEditEnd =false
                inputType="password"
                :maxlength=20
                placeholder="あたらしいパスワード"
                style="margin-top:10px;"
                label="・あたらしいパスワード"
                iconClassName="fas fa-key"
                :isShowErrorMessage="errors.has('newPassword')"
                :errorMessage="errors.first('newPassword')"
                radius="20px"
                ></t-input> 
                <!-- 値の検証時エラーメッセージ -->
                <!-- <span class="validate-error-message" v-if="errors.has('newPassword')">
                  <i class="fas fa-exclamation-triangle"></i>{{ errors.first('newPassword') }}
                </span> -->
                <t-input v-model="ruleForm.checkNewPassword"
                v-validate="{required:true,is:ruleForm.NewPassword}"  
                name="checkNewPassword"
                v-bind:class="{disable:IsLoadingPassword}"
                :enterToEditEnd =false
                inputType="password"
                :maxlength=20
                placeholder="あたらしいパスワードをもういちど"
                label="・あたらしいパスワードをもういちどかくにん"
                :isShowErrorMessage="errors.has('checkNewPassword')"
                :errorMessage="errors.first('checkNewPassword')"
                iconClassName="fas fa-key"
                radius="20px"
                ></t-input> 
                <!-- 値の検証時エラーメッセージ -->
                <!-- <span class="validate-error-message" v-if="errors.has('checkNewPassword')">
                  <i class="fas fa-exclamation-triangle"></i>{{ errors.first('checkNewPassword') }}
                </span> -->

                <!-- ボタン類 -->
　　            <div class="row-buttons">
                  <div @click="SavePassword" v-bind:class="{disable:IsLoadingPassword}" class="button-edit">
                    <i class="far fa-check-circle"></i>
                    保存
                  </div>
                  <div @click="SavePassword('cancel')" v-bind:class="{disable:IsLoadingPassword}" class="button-edit cancel">
                    <i class="far fa-times-circle"></i>
                    キャンセル
                  </div>
                </div>
    
</div>
</div>

<!-- =======================
自己紹介:
=======================-->
<div  class="row"
v-bind:class="{disable:CurrentEditContet!=='introduction' && CurrentEditContet!==''}" 
 style="margin-top:10px">
 <!-- 表示ver -->
  <div v-if="CurrentEditContet!=='introduction'" class="row-input">
    <label>・じこしょうかい</label>
    <div class="input-content readonly">    
      <i class="fas fa-align-left"></i>
      <div class="split-border">&nbsp;</div>    
      <div class="introduction readonly"
       style="white-space:pre-wrap;"
       contenteditable="false" >{{loginUser.introduction}}</div>
      <div @click="EditIntroduction" class="button-edit">
          <i class="far fa-edit"></i>
          かえる
      </div>
    </div>
  </div>

  <!-- 編集ver -->
  <div v-if="CurrentEditContet==='introduction'" class="row-input loading-container">
    <!-- ローディング -->
    <t-loading class="loading-item" :isLoading="IsLoadingIntroduction"></t-loading>

    <label>・自己紹介（100文字まで)</label>
    <div class="input-content" v-bind:class="{disable:IsLoadingIntroduction}">    
      <i class="fas fa-align-left"></i>
      <div class="split-border">&nbsp;</div> 
      <!-- 入力部分    -->
      <editable class="introduction"
      ref="introductionEditor"
      v-validate="'max:100'" 
      name="introduction"
      v-model="ruleForm.introduction">
      </editable>
    </div>
    <!-- 値の検証時エラーメッセージ -->
    <span class="validate-error-message" v-if="errors.has('introduction')">
      <i class="fas fa-exclamation-triangle"></i>{{ errors.first('introduction') }}
    </span>

　　<!-- ボタン類 -->
　　<div class="row-buttons">
      <div @click="SaveIntroduction" 
      v-bind:class="{disable:IsLoadingIntroduction || errors.has('introduction')}" class="button-edit">
        <i class="far fa-check-circle"></i>
        保存
      </div>
      <div @click="SaveIntroduction('cancel')" v-bind:class="{disable:IsLoadingIntroduction}" class="button-edit cancel">
        <i class="far fa-times-circle"></i>
        キャンセル
      </div>
    </div>
    <!-- //ボタン類 -->

  </div>

</div>



<!-- =======================
匿名ユーザー:アカウント登録用
=======================-->
<div  class="row"
v-if="rawUser.isAnonymous==true"
v-bind:class="{disable:CurrentEditContet!=='introduction' && CurrentEditContet!==''}" 
 style="margin-top:10px">
    アカウントを登録

    <AnonymousRegistAccount />
 </div>


<!-- <div style="margin-top:20px;">
<label>・せいべつ</label>
             <div class="gender-select" >
               <div v-bind:class="{on:ruleForm.gender ==='women',off:ruleForm.gender !=='women'}" class="gender-box" @click="ruleForm.gender='women'" >
<i class="fas fa-female"></i>
<label>おんな</label>
                 </div>
                 <div v-bind:class="{on:ruleForm.gender ==='men',off:ruleForm.gender !=='men'}" class="gender-box" @click="ruleForm.gender='men'">
<i class="fas fa-male"></i>
<label>おとこ</label>
                 </div>

               </div>
               </div> -->


                <!-- <div @click="SaveProfile" class="button-save">
                  <i class="far fa-check-circle"></i>
                  保存</div> -->

                  

  </div>

 


  </div>





  </div>
</template>

<script>
import AnonymousRegistAccount from "../organisms/AnonymousRegistAccount"
import TInput from "../TInput";
import Tloading from "../TLoading";
import Editable from "../Editable";

//検証メッセージのカスタマイズ処理
import { Validator } from 'vee-validate'
const dict = {
  custom: {
    email: {
      required: 'メールアドレスをいれてね！',
      email: 'ただしいメールアドレスをいれてね！',
      max: '※ 254文字以内でいれてね',
    },
    userName:{
      required: 'なまえをいれてね',
      max: '20文字以内でいれてね',
    },
    passwordForUpdateEmail:{
      required: '確認のパスワードをいれてね',
      min:'6文字から20文字以内でいれてね',
      max: '6文字から20文字以内でいれてね'
    },
    nowPassword:{
      required: 'いまのパスワードをいれてね',
      min:'6文字から20文字以内でいれてね',
      max: '6文字から20文字以内でいれてね'
    },
    newPassword:{
      required: '新しいパスワードをいれてね',
      min: '6文字から20文字以内でいれてね',
      max: '6文字から20文字以内でいれてね'
    },
    checkNewPassword:{
      is: '同じパスワードをいれてね',
    },
    introduction:{
      max: '紹介文は100文字以内でいれてね'
    }
  }
}
Validator.localize('ja', dict)


export default {
  name: "ProfilePage",
  components: {
    TInput,
    AnonymousRegistAccount,
     "t-loading":Tloading,
     "editable":Editable
  },

  data() {
    return {
      CurrentEditContet:"",
      IsLoadingName:false,
      IsLoadingEmail:false,
      IsLoadingPassword:false,
      IsLoadingIntroduction:false,
      message:"",
      ruleForm: {
        name: "",
        email: "",
        PasswordForUpdateEmail:"",
        Password:"",
        NewPassword: "",
        checkNewPassword: "",
        DammyPassword:"●●●●●●●●",
        gender:"men",
        introduction:""
      },
      
    };
  },
  mounted() {
    
       //this.ruleForm.name = this.loginUser.displayName;
       this.ruleForm.email = this.loginUser.email;
       //this.ruleForm.introduction = this.loginUser.introduction;
  },
  computed: {
    // introduction:{
    //   get:function(){
    //     return this.ruleForm.introduction;

    //   },
    //   set:function(val){
    //     if(val.length>10){
    //       return;
    //     }
    //     this.ruleForm.introduction =val;
    //   }
    // },
    // backButtonText(){
    //   return (window.history.length > 1 ? "戻る": "タイトル一覧へ");

    // },

    IsAnonymous(){
      return this.$store.getters.loginUser.isAnonymous
      
    },

    rawUser() {
      return this.$store.getters.loginUser;
    },

     providerId() {
       //return  this.$store.getters.loginUser.providerData[0].providerId;
       if( this.$store.getters.loginUser.providerData.length>0)
       {
          return  this.$store.getters.loginUser.providerData[0].providerId;
       }
      return "";
    },


    loginUser() {
      return this.$store.getters.User;
    },
    isLogin() {
      return this.$store.getters.isLogin;
    }
  },
  watch:{
  //   loginUser: {
  //    handler(val){
  //      this.ruleForm.name = val.displayName;
  //      this.ruleForm.email = val.email;
  //    },
  // }
   
  },
  methods: {

   

    

    //========================
    //１つ前のページへ戻る
    //========================
    GoBack () {
      window.history.length > 1
        ? this.$router.go(-1)
        : this.$router.push('/')
    },
    //========================
    //編集:自己紹介
    //========================
    EditIntroduction(){
      this.CurrentEditContet='introduction'
      this.ruleForm.introduction = this.loginUser.introduction;
       this.$nextTick(() => {
            this.$refs.introductionEditor.ToFocus();
          });  

    },
    //========================
    //保存:自己紹介
    //========================
    SaveIntroduction(val){
      
      if(val==="cancel")
      {
        this.CurrentEditContet=''
        return
      }

      this.IsLoadingIntroduction = true;

      var callback = function(result,msg) {
        if(result === false)
        {
          alert(msg);
        }
        this.IsLoadingIntroduction = false
        this.CurrentEditContet=''
      }.bind(this);

      this.$store.dispatch("UpdateUserProfileIntroduction", {
            introduction: this.ruleForm.introduction,
            callback:callback
          });
    },
    //========================
    //編集:名前
    //========================
    EditName(){
      this.CurrentEditContet='name'
      this.ruleForm.name = this.loginUser.displayName;

      this.$nextTick(() => {
         this.$refs.userNameInput.ToFocus();
      });  
    },
    SaveName(val){

      //TODO:前の名前と同一なら処理しない
      //TODO:空白禁止

      if(val==="cancel")
      {
        this.CurrentEditContet=''
        return
      }
      //値の検証
      this.$validator.validate("userName").then(result => {
        if (!result) {
          return;
        }
      });
    

      this.IsLoadingName=true;

      var callback = function(result,msg) {
        if(result === false)
        {
          alert(msg);
        }
        this.IsLoadingName=false;
        this.CurrentEditContet=''
      }.bind(this);

      this.$store.dispatch("UpdateUserProfileName", {
            name: this.ruleForm.name,
            callback:callback
          });

      
    },
    //========================
    //
    //========================
    EditPassword(){
      this.CurrentEditContet='password'
       this.$nextTick(() => {
            this.$refs.nowPasswordInput.ToFocus();
          });  

    },
    SavePassword(val){
      if(val==="cancel")
      {
        this.CurrentEditContet=''
        return
      }
      if(this.ruleForm.checkNewPassword!==this.ruleForm.NewPassword)
      {
        alert("新しいパスワードの確認が正しくないよ！")
        return;
      }
      if(this.ruleForm.checkNewPassword.length===0)
      {
        alert("新しいパスワードを入力してね")
        return;
      }

      var callback = function(result,msg) {
        if(result === false)
        {

          this.IsLoadingPassword=false;
          this.ruleForm.PasswordForUpdateEmail=''
          alert(msg);
          return;
        }
        this.IsLoadingPassword=false;
        this.CurrentEditContet=''
        this.ruleForm.NewPassword=''
        this.ruleForm.Password=''
        this.ruleForm.checkNewPassword=''
      }.bind(this);

      this.IsLoadingPassword = true;


      this.$store.dispatch("UpdateUserProfilePassword", {
            newPassword: this.ruleForm.NewPassword,
            password: this.ruleForm.Password,
            callback: callback
      });



      //this.CurrentEditContet=''

    },
    //========================
    //
    //========================
    EditMailAddress(){
          this.CurrentEditContet='email'
          this.$nextTick(() => {
            this.$refs.emailInput.ToFocus();
          });  
    },
    //========================
    //保存処理：Email
    //========================
    SaveEmail(val){
      if(val==="cancel")
      {
        this.CurrentEditContet=''
        return
      }
      // if(password.length===0)
      // {
      //   return;
      // }
      // if(password.length===0)
      // {
      //   return;
      // }

      var callback = function(result,msg) {
        if(result === false)
        {

          this.IsLoadingEmail=false;
          this.ruleForm.PasswordForUpdateEmail=''
          alert(msg);
          return;
        }
        this.IsLoadingEmail=false;
        this.CurrentEditContet=''
        this.ruleForm.PasswordForUpdateEmail=''
      }.bind(this);

      this.IsLoadingEmail = true;


      this.$store.dispatch("UpdateUserProfileEmail", {
            newEmail: this.ruleForm.email,
            password: this.ruleForm.PasswordForUpdateEmail,
            callback: callback
      });


      //this.CurrentEditContet=''

    },
    //========================
    //保存
    //========================
    SaveProfile() {
      this.$store.dispatch("UpdateUserProfile", {
            name: this.ruleForm.name,
            gender:"男"
          });


      return
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.$store.dispatch("UpdateUser", {
            name: this.ruleForm.name,
            email: this.ruleForm.email,
            password: this.ruleForm.pass
          });
        } else {
          alert("eror");
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>


.profile-container{
  outline-width: 0;
  //background:yellow;
 
  display: flex;
  justify-content: center;
  align-items: center;

  
}

.profile-main-content{
  
//  padding-left:20px;
  //flex:1 1 auto;
   width:98%;
   max-width:600px;
  background:white;
  border-radius: 10px;
  padding: 20px;
  padding-top: 10px;

}

//---------------
// :戻るボタン
//---------------
.back{
  text-align: left;
  
  display: inline-block;
  font-size: 22px;
  text-decoration: none;
  margin-bottom: 8px;
  & > i {
    margin-right: 8px;
  }
  &:hover {
    color: coral;
  }

  color: #42b983;
  cursor: pointer;

}


//---------------
// :無効時のスタイル
//---------------
.disable {
  opacity: 0.3;
  cursor: default;
  pointer-events: none; // クリック、タッチを無効化
  // -文字を選択させない
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
}

.row-buttons{
  margin-top:15px;
  margin-bottom:25px;
  padding-left:10px;

}

//---------------
// 行
//---------------
.row{
   border-bottom:1px dotted #42b983;
    &:last-child{
      border-bottom:none;
    }
}

.row-flex{
  display:flex;
  position: relative;
  padding-top:20px;
 
 


     //ボタン：通常時の位置
     //※編集時とtopが変わるのでここで指定している
     .button-edit{
       margin-top:30px;
     }


    //---------------
    // :無効時のスタイル
    //---------------
    .disable {
      opacity: 0.3;
      cursor: default;
      pointer-events: none; // クリック、タッチを無効化
      // -文字を選択させない
      -moz-user-select: none;
      -webkit-user-select: none;
      -ms-user-select: none;
    }

  

  .loading-item {
    position: absolute;
    top: 40px;
    left: 80px;
    z-index: 999;
    transform: scale(1);
  }
}


.loading-container
{
  .loading-item {
    position: absolute;
    top: 40px;
    left: 80px;
    z-index: 999;
    transform: scale(1);
  }
}


.row-input{
  position: relative;
  padding-top:20px;
  &>label{
    font-weight: 600;
    display: block;
    margin-bottom:3px;
    margin-left:8px;
    font-size:14px;
    color: #42b983;
  }

  
  .input-content{
    background: #f2faf6;
    border: 1px solid #666;
    margin-bottom:20px;
    border-radius:20px;
    padding:10px;
    display:flex;
    align-items: center;
    &.readonly{
      border:none;
      background:transparent;
    }

    & > i {
    margin-left: 20px;
    font-size: 20px;
    color: #42b983;
    transition: 0.3s;
  }

  & > .split-border{
    flex: 0;
    opacity:0.5;
    margin-left:18px;
    height:80%;
    display: inline-block;
    border-left:solid 2px #42b983;
  }

  }

  .introduction{
    margin-left:15px;
    font-weight: 600;
    font-size: 14px;
    color:#42b983;
    //what: contenteditable設定で発生する枠線を消している
    border: none;
    outline-width: 0;
    flex-grow: 1;
    &.readonly{
      //color:#42b983;
    }
    &:focus{
      outline:none;
    }
    
  }
  .introduction-textarea
  {
    font-size:16px;
    border:none;
    background:transparent;
    outline-width: 0;
  }
}



h1,
h2 {
  font-weight: 800;
  display: inline-block;
  //縁取り文字
  color:white;
  -webkit-text-stroke-width: 1px;
  -webkit-text-stroke-color: #666;
  text-shadow: 1px 2px 0px #666; 

  & > ruby > rt {
    color: #666;
    font-size: 11px;
    -webkit-text-stroke-width: 0px;
    text-shadow: none;
  }


  & > span{
    display: block;
    text-align: center;
    font-weight: normal;
    font-size:16px;
    margin-top:10px;
    text-shadow: none;
  }
}


 //--------------
 //ボタン:保存
 //--------------
.button-save{
  cursor: pointer;
  margin-top:30px;
  color:white;
  text-align: center;
  border-radius: 40px;
  padding-top:13px;
  height:40px;
  vertical-align: middle;
  width:150px;
  background:coral;
  letter-spacing: 10px;
  font-weight: 600;
  font-size:18px;

  &:hover{

  }
}

//--------------
 //ボタン:編集
 //--------------
.button-edit{
  
  margin-left: auto;
  cursor: pointer;
  color:#fff;
  display: inline-block;
  border:1px solid #42b983;
  background:#42b983;
  text-align: center;
  border-radius: 18px;
  padding-top:10px;
  padding-left:20px;
  padding-right:18px;
  height:25px;
  vertical-align: middle;
  letter-spacing: 32x;
  font-weight: 600;
  font-size:14px;


  &.cancel{
      background:#fff;
      color:#42b983;
  }

  &:hover{
    opacity:0.8;

  }

  & > i{
    margin-right:5px;
    font-weight: normal;
  }
}

//--------------
 //ラベル
 //--------------
label{
    font-weight: 600;
    display: block;
    margin-bottom:3px;
    margin-left:8px;
    font-size:18px;
    //color: #42b983;
  }

.gender-select{
  display:flex;
}
.gender-box{
  cursor:pointer;
  display:flex;
  margin-right:10px;
  width:70px;
  height:70px;
  padding-top:3px;

  border-radius: 20px;
   justify-content: center;
    align-items: center;
    flex-direction: column;
    color:#ccc;
    border:1px solid #ccc;
    &.on{
      border:1px solid #42b983;
      color:#42b983;
    }

    &:hover{
      background:#f2faf6;
    }
  & > i{
    font-size:40px;


  }

  & > label{
    font-weight: 600;
    font-size:12px;

    
  }
}
.c-title-input {
  position:relative;
  transition: 0.3s;
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 50px;

  & > i {
    margin-left: 20px;
    font-size: 20px;
    color: #42b983;
    transition: 0.3s;
  }

  & > div.split-border{
    flex: 0;
    opacity:0.5;
    margin-left:18px;
    height:60%;
    display: inline-block;
    border-left:solid 2px #42b983;
  }
  & > span {
   
    color: #42b983;
    font-weight: 600;
    flex: 1;
    font-size: 14px;
    margin-left: 16px;
  }
}



</style>



// WEBPACK FOOTER //
// src/components/pages/ProfilePage.vue